import styled from 'styled-components';

export const HeaderItm = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  position: relative;
`;

export const LogoBtn = styled.button`
  background-color: transparent;
  border: none;
`;

export const LogoImg = styled.img`
  width: 102px;
  height: 48px;
`;
